import React from 'react';
import { CompanyRegistration, CompanyRegistrationErrors } from '../../../types';

interface ContactInfoSectionProps {
  formData: Partial<CompanyRegistration>;
  errors: CompanyRegistrationErrors;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
}

const ContactInfoSection: React.FC<ContactInfoSectionProps> = ({
  formData,
  errors,
  onInputChange
}) => {
  return (
    <>
      <h3 className="uk-heading-small uk-margin-small-top">Información de Contacto</h3>
      
      <div className="uk-grid uk-grid-small" data-uk-grid>
        <div className="uk-width-1-4@m">
          <div className="uk-margin-small">
            <label className="uk-form-label" htmlFor="ddn">DDN *</label>
            <div className="uk-form-controls">
              <input 
                className={`uk-input ${errors.ddn ? 'uk-form-danger' : ''}`}
                id="ddn" 
                name="ddn"
                type="text" 
                placeholder="Código de área" 
                value={formData.ddn || ''}
                onChange={onInputChange}
                required 
                style={{ color: '#333', backgroundColor: '#fff' }}
              />
              {errors.ddn && (
                <div className="uk-text-danger uk-text-small">{errors.ddn}</div>
              )}
            </div>
          </div>
        </div>
        
        <div className="uk-width-3-4@m">
          <div className="uk-margin-small">
            <label className="uk-form-label" htmlFor="telefono1">Teléfono 1 *</label>
            <div className="uk-form-controls">
              <input 
                className={`uk-input ${errors.telefono1 ? 'uk-form-danger' : ''}`}
                id="telefono1" 
                name="telefono1"
                type="tel" 
                placeholder="Número de teléfono principal" 
                value={formData.telefono1 || ''}
                onChange={onInputChange}
                required 
                style={{ color: '#333', backgroundColor: '#fff' }}
              />
              {errors.telefono1 && (
                <div className="uk-text-danger uk-text-small">{errors.telefono1}</div>
              )}
            </div>
          </div>
        </div>
      </div>
      
      <div className="uk-margin-small">
        <label className="uk-form-label" htmlFor="telefono2">Teléfono 2</label>
        <div className="uk-form-controls">
          <input 
            className="uk-input"
            id="telefono2" 
            name="telefono2"
            type="tel" 
            placeholder="Número de teléfono secundario"
            value={formData.telefono2 || ''}
            onChange={onInputChange}
            style={{ color: '#333', backgroundColor: '#fff' }}
          />
        </div>
      </div>
      
      <div className="uk-margin-small">
        <label className="uk-form-label" htmlFor="email">E-mail *</label>
        <div className="uk-form-controls">
          <input 
            className={`uk-input ${errors.email ? 'uk-form-danger' : ''}`}
            id="email" 
            name="email"
            type="email" 
            placeholder="correo@empresa.com" 
            value={formData.email || ''}
            onChange={onInputChange}
            required 
            style={{ color: '#333', backgroundColor: '#fff' }}
          />
          {errors.email && (
            <div className="uk-text-danger uk-text-small">{errors.email}</div>
          )}
        </div>
      </div>
      
      <div className="uk-margin-small">
        <label className="uk-form-label" htmlFor="sitio-web">Sitio Web</label>
        <div className="uk-form-controls">
          <input 
            className="uk-input"
            id="sitio-web" 
            name="sitioWeb"
            type="url" 
            placeholder="https://www.empresa.com"
            value={formData.sitioWeb || ''}
            onChange={onInputChange}
            style={{ color: '#333', backgroundColor: '#fff' }}
          />
        </div>
      </div>
    </>
  );
};

export default ContactInfoSection;
